module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0543e05716fd737ba9be869436343db6.png";